import {
  C,
  P0,
  R,
  S,
  abs,
  core,
  disc,
  dot,
  max,
  min,
  moodK,
} from '../../geometry';

export const dots = {
  name: 'Dots',
  colors: ['#2F9E5B', '#3E63DD'],
  draw(m, t) {
    let spin = 0,
      pose = P0();
    const rad = (i) => {
      if (m === 'happy') return 32 + 4 * abs(S(t * 7 + i * 0.4));
      if (m === 'talking') return 32 + 3 * max(0, S(t * 10 - i * 0.8));
      if (m === 'surprised') return 40;
      if (m === 'paused') return 27;
      return 32 + 0.6 * S(t * 1.6);
    };
    const op = (i) => {
      // Thinking: a bright dot chases round the ring.
      if (m === 'thinking') {
        const head = (t * 6) % 8,
          d0 = abs(i - head),
          d = Math.min(d0, 8 - d0);
        return 0.25 + 0.75 * Math.exp((-d * d) / 1.2);
      }
      return m === 'paused' ? 0.5 : 1;
    };
    if (m === 'thinking') spin = t * 20;
    if (m === 'happy') pose.ty = -2 * abs(S(t * 6));
    return {
      strokes: [...Array(8)].map((_, i) => {
        const a = (i * 45 - 90) * R,
          r = rad(i);
        return {
          c: i % 2 ? 'b' : 'a',
          pts: [
            [50 + r * C(a), 52 + r * S(a)],
            [50 + r * C(a) + 0.01, 52 + r * S(a)],
          ],
          o: op(i),
          spin,
        };
      }),
      eyes: { x: 50, y: 52 },
      pose,
    };
  },
  eyesOn: 'a',
  solid(f, m, t) {
    f.strokes.unshift(core(disc(50, 52, 19 * moodK(m, t))));
    return f;
  },
};
